import axios from 'axios';

const DEFAULT_METHOD = 'post';

const methods = {
  // cart
  'cart.item': { url: '/cart/item' },
  'cart.get_recommendations': { url: '/cart/get_recommendations' },
  'cart.gifts': { url: '/cart/gifts' },
  'cart.remove.user.gifts': { url: '/cart/remove_user_gift' },
  'cart.remove': { url: '/cart/remove' },
  'cart.promocode': { url: '/cart/promocode' },
  'cart.order_date': { url: '/cart/order_date' },
  'cart.get': { url: '/cart/get' },
  'cart.user_gift': { url: '/cart/user_gift' },
  'cart.refresh': { url: '/cart/refresh' },
  'cart.reset': { url: '/cart/reset', method: 'get' },

  'cart.get_server_date': { url: '/cart/get_server_date' },

  // favorites
  'favorites.list': { url: '/favorites/list' },
  'favorites.toggle': { url: '/favorites/toggle' },

  // order
  'order.get_recommendations': { url: '/order/get_recommendations' },
  'order.status': { url: '/order/status' },

  // products
  'product.get': { url: '/product/get' },
  'product.list': { url: '/product/list' },
  'product.recommendations': { url: '/product/get_recommendations' },
  'product.viewed': { url: '/product/viewed' },

  // reviews
  'review.list': { url: '/review/list' },

  // seo
  'seo.page': { url: '/seo/page' },

  // subscribe
  'subscribe.email': { url: '/subscribe/email' },
  'subscribe.confirm': { url: '/subscribe/confirm' },
  'subscribe.unsubscribe': { url: '/subscribe/unsubscribe' },

  // stores
  'store.get_list_city': { url: '/store/get_list_city' },
  'store.get_stopped': { url: '/store/get_stopped' },
  'store.get_stopped_products': { url: '/store/get_stopped_products' },

  // user
  'user.addresses': { url: '/user/addresses' },
  'user.address': { url: '/user/address' },
  'user.remove_address': { url: '/user/remove_address' },
  'user.register_or_auth': { url: '/user/register_or_auth' },
  'user.get_bonuses': { url: '/user/get_bonuses' },
  'user.isExist': { url: '/user/isExist', method: 'get' },
  '/endpoint/phone/validate': {
    url: '/endpoint/phone/validate',
    method: 'get',
    headers: {
      'Api-Version': 3,
    },
  },
};

export default (path, data, params) => {
  if (!methods[path]) {
    throw new { message: `path ${path} not defined` }();
  }

  return axios({
    url: methods[path].url,
    method: methods[path].method || DEFAULT_METHOD,
    data,
    params,
    headers: methods[path].headers || {},
  })
    .then(({ data }) => data)
    .catch((e) => {
      throw e.response;
    });
};
